<main>
  <ng-container *ngIf="displayData.length == 0 && data.mediaData.name">
    <p>Type: {{data.mediaData.type}}</p>
    <p>Nom: {{data.mediaData.name}}</p>

  </ng-container>
  <ng-container *ngIf="displayData.length > 0 && data.mediaData.name">
    <div *ngFor="let item of displayData">
      <p>{{item.name}} : {{item.value}}</p>
      <img  [src]="getUrl(item.value)" onerror="this.style.display='none'"/>
    </div>
  </ng-container>
  <ng-container *ngIf="!data.mediaData.name">
    <p>Aucune donnée enregistré, le document à déjà été supprimé</p>
  </ng-container>
</main>
